import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-34d34931"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "ion-margin-vertical" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "field-container" }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1))
const _hoisted_8 = { class: "ion-text-center" }
const _hoisted_9 = { class: "flex-container" }
const _hoisted_10 = { class: "flex-container" }
const _hoisted_11 = { class: "flex-container" }
const _hoisted_12 = { class: "ion-text-center" }
const _hoisted_13 = { class: "ion-text-center" }
const _hoisted_14 = { class: "ion-text-center" }
const _hoisted_15 = { class: "ion-margin-vertical" }
const _hoisted_16 = { class: "summary-card" }
const _hoisted_17 = { class: "flex-container" }
const _hoisted_18 = { class: "flex-container" }
const _hoisted_19 = { class: "flex-container" }
const _hoisted_20 = { class: "flex-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_ion_text = _resolveComponent("ion-text")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_grid = _resolveComponent("ion-grid")!

  return (_openBlock(), _createElementBlock("div", null, [
    (!_ctx.dataLoaded)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_ion_spinner),
          _createVNode(_component_ion_text, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('LoadingData')), 1)
            ]),
            _: 1
          })
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_ctx.cropMineralFertilization.mineral_fertilization_items.length == '0')
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(_component_ion_text, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('NoData')), 1)
                      ]),
                      _: 1
                    })
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("table", null, [
                    _createElementVNode("thead", null, [
                      _createElementVNode("th", null, _toDisplayString(_ctx.$t('Products')), 1),
                      _createElementVNode("th", null, _toDisplayString(_ctx.$t('Stade')), 1),
                      _createElementVNode("th", null, _toDisplayString(_ctx.$t('AreaSpread')), 1),
                      _createElementVNode("th", null, _toDisplayString(_ctx.$t('TotalQuantity')), 1),
                      _createElementVNode("th", null, _toDisplayString(_ctx.$t('QuantityProSpreadHa')), 1),
                      _createElementVNode("th", null, _toDisplayString(_ctx.$t('Cost')), 1),
                      _createElementVNode("th", null, _toDisplayString(_ctx.$t('QuantityNProHa')), 1),
                      _createElementVNode("th", null, _toDisplayString(_ctx.$t('QuantityPProHa')), 1),
                      _createElementVNode("th", null, _toDisplayString(_ctx.$t('QuantityKProHa')), 1),
                      _hoisted_7
                    ]),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cropMineralFertilization.mineral_fertilization_items, (item, index) => {
                        return (_openBlock(), _createElementBlock("tr", { key: index }, [
                          _createElementVNode("td", null, _toDisplayString(item.product_name), 1),
                          _createElementVNode("td", null, _toDisplayString(item.plant_state_name), 1),
                          _createElementVNode("td", _hoisted_8, _toDisplayString(item.area_spread_percent), 1),
                          _createElementVNode("td", null, [
                            _createElementVNode("div", _hoisted_9, [
                              _createVNode(_component_ion_text, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(item.total_quantity), 1)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_ion_text, { class: "ion-text-nowrap" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t('UnitKg')), 1)
                                ]),
                                _: 1
                              })
                            ])
                          ]),
                          _createElementVNode("td", null, [
                            _createElementVNode("div", _hoisted_10, [
                              _createVNode(_component_ion_text, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(item.quantity_pro_spread_ha), 1)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_ion_text, { class: "ion-text-nowrap" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t('UnitKgProHa')), 1)
                                ]),
                                _: 1
                              })
                            ])
                          ]),
                          _createElementVNode("td", null, [
                            _createElementVNode("div", _hoisted_11, [
                              _createVNode(_component_ion_text, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(item.cost), 1)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_ion_text, { class: "ion-text-nowrap" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t('UnitEuroProT')), 1)
                                ]),
                                _: 1
                              })
                            ])
                          ]),
                          _createElementVNode("td", _hoisted_12, _toDisplayString(item.units_n), 1),
                          _createElementVNode("td", _hoisted_13, _toDisplayString(item.units_p), 1),
                          _createElementVNode("td", _hoisted_14, _toDisplayString(item.units_k), 1)
                        ]))
                      }), 128))
                    ])
                  ])
                ]))
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createVNode(_component_ion_grid, null, {
              default: _withCtx(() => [
                _createVNode(_component_ion_row, { class: "ion-justify-content-center" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_col, {
                      size: "auto",
                      class: "flex-container"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_16, [
                          _createElementVNode("div", _hoisted_17, [
                            _createVNode(_component_ion_text, null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('TotalUnitsN')) + " " + _toDisplayString(_ctx.cropMineralFertilization.units_n), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_text, { class: "ion-text-nowrap" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('UnitProHa')), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_18, [
                            _createVNode(_component_ion_text, null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('TotalUnitsP')) + " " + _toDisplayString(_ctx.cropMineralFertilization.units_p), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_text, { class: "ion-text-nowrap" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('UnitProHa')), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_19, [
                            _createVNode(_component_ion_text, null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('TotalUnitsK')) + " " + _toDisplayString(_ctx.cropMineralFertilization.units_k), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_text, { class: "ion-text-nowrap" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('UnitProHa')), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_20, [
                            _createVNode(_component_ion_text, null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('TotalCost')) + " " + _toDisplayString(_ctx.cropMineralFertilization.cost), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_text, { class: "ion-text-nowrap" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('UnitEuroProHa')), 1)
                              ]),
                              _: 1
                            })
                          ])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ]))
  ]))
}